<template>
  <div class="login-nav">
    <div class="nav">
      <div
        style="cursor:pointer"
        class="nav-button red"
        :class="{choose:index == 1 }"
        @click="chooseLogin (1)"
      >终端入口</div>
      <div
        style="cursor:pointer"
        class="nav-button orange"
        :class="{choose:index == 2 }"
        @click="chooseLogin (2)"
      >商业入口</div>
      <div
        style="cursor:pointer"
        class="nav-button blue"
        :class="{choose:index == 3 }"
        @click="chooseLogin (3)"
      >后台管理</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      index: 1
    }
  },
  methods: {
    chooseLogin (loginWay) {
      // 选择登录的系统 1为终端 2为商业 3为后台
      this.$emit('loginWay', loginWay)
      switch (loginWay) {
        case 1:
          this.index = 1
          break
        case 2:
          this.index = 2
          break
        case 3:
          this.index = 3
          break
      }
    }
  }
}
</script>
<style scoped>
.login-nav {
  width: 100%;
  height: 100%;
}
.nav {
  width: 100%;
  height: 100%;
}
.nav-button {
  display: inline-block;
  padding: 0px 15px;
  font-weight: 700;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 33.333333%;
  border: 2px solid #ffffff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  writing-mode: vertical-lr;
}
.red {
  background-color: #e62129;
}
.blue {
  background-color: #009be7;
}
.orange {
  background-color: #fea31f;
}
.choose {
  border-left: 0;
  border-top: 0;
}
</style>
